/**
 * 培养方案hooks
 */
import { ref, inject, reactive } from 'vue'
import { IPageListObject, ITrainingPlanObject, IYearObject } from '../type'
export default () => {
  const { getTrainingPlanYearList, getTrainingPlanPageList } = inject<any>('$http')

  const searchInfo = reactive({
    keyword: '',
    grade: '',
    organ_id: ''
  })
  /**
   * 年份列表
   */
  const yearList = ref<IYearObject[]>([])
  const getYearList = async () => {
    const res = await getTrainingPlanYearList({ type: 2 })
    yearList.value = res || []
    if (yearList.value.length) {
      searchInfo.grade = yearList.value[0].grade
      getTrainingPlanList()
    }
  }

  const pageInfo = reactive({
    pageNum: 1,
    pageSize: 9,
    total: 0
  })
  const trainingPlanList = ref<ITrainingPlanObject[]>([])

  /**
   * 培养方案
   */
  const getTrainingPlanList = async () => {
    let params = {
      '_pageable.page': pageInfo.pageNum - 1,
      '_pageable.size': pageInfo.pageSize,
      ...searchInfo
    }
    const { content, totalElements }: IPageListObject<ITrainingPlanObject> = await getTrainingPlanPageList(params)
    trainingPlanList.value = content
    pageInfo.total = +totalElements || 0
  }

  /**
   * 搜索
   */
  const handleSearch = () => {
    pageInfo.pageNum = 1
    getTrainingPlanList()
  }

  /**
   * 分页变化
   * @param index 分页索引
   */
  const handlePageChange = index => {
    pageInfo.pageNum = index
    getTrainingPlanList()
  }
  return {
    searchInfo,
    pageInfo,
    yearList,
    trainingPlanList,
    getYearList,
    getTrainingPlanList,
    handleSearch,
    handlePageChange
  }
}
